module.exports = __webpack_public_path__ + "img/add-products.bc2f987a.svg";